import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import { Link } from "react-router-dom";
import Button from "../../atomic/Button/Button";

const Root = styled.table`
  font-size: 14px;
  width: 100%;
  tr {
    width: 100%;
    max-width: 100%;
  }
  td {
    text-align: center;
    height: 40px;
  }
  td.info {
    text-align: left;
    padding-left: 10px;
  }
  th.info {
    text-align: left;
    padding-left: 10px;
  }
  th {
    border-bottom: 1px solid ${props => props.theme.color6};
    background-color: ${props => props.theme.color5};
    height: 40px;
  }
  .odd {
    background-color: ${props => props.theme.color5};
  }
`;

export default withTheme(({ theme, blogs }) => {
  const less = blogs.filter(l => l.status !== "deleted");
  return (
    <Root>
      <thead>
        <tr>
          <th>Title</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {less.map((l, i) => {
          return (
            <tr key={l.id} className={i % 2 ? "odd" : ""}>
              <td>{l.title}</td>
              <td>
                {l.status !== "Draft" && l.status}
                {l.status === "Draft" && (
                  <>
                    <Link to={"/post/edit/" + l.id}>
                      <FontAwesomeIcon
                        icon={["fas", "pen"]}
                        size="1x"
                        color={theme.color1}
                      />
                    </Link>
                    <Link to={"/posts/delete/" + l.id}>
                      <FontAwesomeIcon
                        icon={["fas", "trash-alt"]}
                        size="1x"
                        color={theme.color1}
                      />
                    </Link>
                  </>
                )}
              </td>
              <td>
                {l.status === "Draft" && (
                  <Link to={"/posts/publish/" + l.id}>
                    <Button>Publish</Button>
                  </Link>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Root>
  );
});
